import vmClient from 'app/services/vmClient';
import { IEntityType, IEntity, Entity } from 'app/types/entity';
import { Participant, RecordizedParticipant } from 'app/constants/schemas/rtc/Participant';
import { Server } from 'app/constants/schemas/rtc/Server';
import * as io from 'io-ts';
import { IdentityEntityStringIdCodec } from 'app/types/entity/codecs';

export interface IRecordizedJoinResult extends IEntity {
  attributes: {
    token: string;
  },
  nestedAssociations: {
    server: Server;
    participant: RecordizedParticipant;
  },
}

export type RecordizedJoinResult = Entity<IRecordizedJoinResult>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RecordizedJoinResult: IEntityType<IRecordizedJoinResult> = vmClient.defineClass({
  typeName: 'Rtc.JoinResult',
  version: 1,

  attributes: {
    token: { type: 'string', notNull: true },
  },

  associations: {
    server: { type: Server, notNull: true },
    participant: { type: Participant, notNull: true },
  },
});

interface IJoinResultSupplementalData {
  [index: string]: { secret: string };
}

export const JoinResultSupplementalData: io.Type<IJoinResultSupplementalData> = io.dictionary(
  IdentityEntityStringIdCodec,
  io.type({
    secret: io.string,
  }),
);
